import React from "react";
import GameContainer from "../../../../../edu_lms/components/Game";
import FindingCorrectMistakesContainer from "../../../../../edu_lms/components/Game/FindingCorrectMistakes";

const FindCorrectMistakes = ({ activity, bookId, showResult }) => {
	return (
		<GameContainer data={activity}>
			<FindingCorrectMistakesContainer data={activity} objectId={bookId} showResult={showResult}/>
		</GameContainer>
	);
};

export default FindCorrectMistakes;
